import React from 'react';
import ReactDOM from 'react-dom/client';
import {ChakraProvider} from '@chakra-ui/react'
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
if (process.env.NODE_ENV !== 'development') {
    root.render(
        <React.StrictMode>
            <ChakraProvider>
                <App/>
            </ChakraProvider>
        </React.StrictMode>
    );
} else {
    root.render(
        <React.StrictMode>
            <ChakraProvider>
                <App/>
            </ChakraProvider>
        </React.StrictMode>
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
